@import "./sellalong-powered-by.css";

:host {
  color: var(--sellalong-colour-primary, #000);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.sellalong-powered-by-logo {
  margin-top: 2px;
}

.sellalong-powered-by-link {
  color: var(--sellalong-colour-primary, #000);
  font-size: 15px;
}
